/** Footer watermark on exported/shared image cards (Miracle Calculator + Meme Studio). */
export const EXPORT_WATERMARK_TEXT = 'VOTENATIONS.COM';
